<template>
    <x-container pa-0>
        <x-layout mb-3>
            <x-flex xs12>
                <x-autocomplete
                    v-model="submissionData.choice_of_law_id"
                    :items="choicesOfLaw"
                    class="required"
                    label="Choice of law and Jurisdiction"
                    placeholder=" "
                    item-value="id"
                    item-text="name"
                    :rules="[v => ruleRequired(v, 'Choice of law and Jurisdiction')]"
                    append-icon="keyboard_arrow_down"
                />
            </x-flex>
        </x-layout>

        <x-layout mb-3>
            <x-flex xs12>
                <x-textarea
                    v-model="submissionData.interest"
                    class="required"
                    label="Interest"
                    placeholder=" "
                    :rules="[v => ruleRequired(v, 'Interest')]"
                />
            </x-flex>
        </x-layout>

        <taxes-questions :submissionData="submissionData"/>

        <x-layout mb-3>
            <x-flex xs12>
                <x-autocomplete
                    v-model="submissionData.regulatory_risk_location_id"
                    :items="countries"
                    class="required"
                    label="Regulatory Risk Location"
                    placeholder=" "
                    :rules="[v => ruleRequired(v, 'Regulatory Risk Location')]"
                    append-icon="keyboard_arrow_down"
                    item-value="id"
                    item-text="name"
                    required
                    :menu-props="{ offsetY: true }"
                />
            </x-flex>
        </x-layout>

        <x-layout mb-3>
            <x-flex xs12>
                <x-text-field
                    v-model="submissionData.us_classification"
                    class="required"
                    label="US classification"
                    placeholder=" "
                    required
                    :rules="[
                        v => ruleRequired(v, 'US classification'),
                        v => ruleMaxCharacters(v, 300, 'US classification')
                    ]"
                />
            </x-flex>
        </x-layout>

        <allocation-of-premium-questions :submissionData="submissionData"/>

        <x-layout mb-3>
            <x-flex xs12>
                <x-autocomplete
                    v-model="submissionData.regulatory_client_classification"
                    :items="regulatoryClientClassifications"
                    class="required"
                    label="Regulatory Client Classification"
                    placeholder=" "
                    :rules="[v => ruleRequired(v, 'Regulatory Client Classification')]"
                    append-icon="keyboard_arrow_down"
                    required
                    :menu-props="{ offsetY: true }"
                />
            </x-flex>
        </x-layout>

        <x-layout mb-3>
            <x-flex xs12>
                <x-text-field
                    v-model="submissionData.adjustment_premium_period_of_credit"
                    label="Adjustment Premium Period of Credit (if applicable)"
                    placeholder=" "
                    :rules="[
                        v => ruleNumeric(v, 'Adjustment Premium Period of Credit (if applicable)')
                    ]"
                />
            </x-flex>
        </x-layout>

        <x-layout>
            <x-flex xs12>
                <x-text-field
                    v-model="submissionData.overseas_broker_address"
                    label="Overseas Broker Address"
                    placeholder=" "
                />
            </x-flex>
        </x-layout>
    </x-container>
</template>

<script>
import AllocationOfPremiumQuestions from '~/components/Broker/SubmissionWizard/AllocationOfPremiumQuestions.vue';
import TaxesQuestions from '~/components/Broker/SubmissionWizard/TaxesQuestions.vue';
import rules from '~/mixins/rules';

export default {
    props: {
        submissionData: {
            type: Object,
            default() {
                return {}
            }
        },
    },
    mixins: [rules],
    components: {
        AllocationOfPremiumQuestions,
        TaxesQuestions,
    },
    data() {
        return {
            choicesOfLaw: [],
            countries: [],
            regulatoryClientClassifications: ['Large risks', 'Reinsurance']
        }
    },
    mounted() {
        this.fetchData();
    },
    methods: {
        fetchData() {
            const mountRequests = [];

            mountRequests.push(axios.get(this.$root.api(`law-jurisdiction`)).then(res => {
                this.choicesOfLaw = res.data.data;
            }));

            mountRequests.push(axios.get(this.$root.api(`country`)).then(res => {
                this.countries = res.data.data;
            }));

            axios.all(mountRequests);
        }
    }
}
</script>

<style>

</style>
